<template>
  <v-autocomplete
    :items="languages"
    item-text="name"
    item-value="code"
    dense
    chips
    small-chips
    label="Languages"
    multiple
    solo
    @change="handleChange"
    v-model="selectedLanguages"
  >
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        @click="data.select"
        @click:close="remove(data.item)"
      >
        {{ data.item.name }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "VueLanguageSelect",
  props: {
    value: {
      type: Array,
    },
  },
  created: function () {
    let that = this;

    fetch("https://ki.hs-kl.de/stillepost/api/translate/languages")
      .then((response) => response.json())
      .then((languages) => {
        that.languages = languages;
      });
  },
  data() {
    return {
      languages: [],
      selectedLanguages: this.value,
    };
  },
  methods: {
    handleChange() {
      this.$emit("input", this.selectedLanguages);
    },
    remove(item) {
      const index = this.selectedLanguages.indexOf(item.code);
      if (index >= 0) this.selectedLanguages.splice(index, 1);
    },
  },
};
</script>
